import React from 'react';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { brandingInfo } from '@config';

const useStyles = makeStyles(theme => ({
	root: {
		overflow: 'hidden',
		'& .logo-icon': {
			width: 44,
			height: 44,
			transition: theme.transitions.create(['width', 'height'], {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		},
		'& .react-badge, & .logo-text': {
			transition: theme.transitions.create('opacity', {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		},
		'& .logo-text': {
			whiteSpace: 'nowrap'
		}
	},
	reactBadge: {
		backgroundColor: 'rgba(0,0,0,0.6)',
		color: '#61DAFB'
	}
}));

const Logo = () => {
	const classes = useStyles();

	return (
		<div className={clsx(classes.root, 'flex items-center')}>
			<img className="logo-icon" src={brandingInfo.logo} alt="logo" />
			<Typography className="text-14 ml-12 font-light logo-text" color="textPrimary">
				{brandingInfo.name}
			</Typography>
		</div>
	);
};

export default Logo;
